import { useState, useEffect } from 'react';

export const usePreviewSeekAd = (jobAdId: number) => {
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    const getPreviewData = async () => {
      try {
        const response = await fetch(`/api/v4/seek/job_ads/${jobAdId}/preview`, {
          method: 'POST'
        });
        const data = await response.json();
        setPreviewUrl(data.url);
      } catch (e) {
        console.error(e);
      }
    };
    getPreviewData();
  }, [jobAdId]);

  return { previewUrl };
};
